import { EnvironmentConfig } from '@ppg/core/models';

export const environment: EnvironmentConfig = {
  name: 'prod',
  production: true,
  baseUrl: '/',
  signInRedirectUrl: '/MicrosoftIdentity/Account/SignIn',
};
